export default __webpack_public_path__ + "static/char-v-49-ja-aafe768f10c43661dd88fd929e8ffe41.mp4";